"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var events_1 = require('events');
var Chunker = (function (_super) {
    __extends(Chunker, _super);
    function Chunker(opts) {
        _super.call(this);
        this.distance = opts.chunkDistance || 2;
        this.chunkSize = opts.chunkSize || 32;
        this.cubeSize = opts.cubeSize || 25;
        this.generateVoxelChunk = opts.generateVoxelChunk;
        this.chunks = {};
        this.meshes = {};
        if ((this.chunkSize & this.chunkSize - 1) !== 0) {
            throw new Error('chunkSize must be a power of 2');
        }
        var bits = 0;
        for (var size = this.chunkSize; size > 0; size >>= 1) {
            bits++;
        }
        this.chunkBits = bits - 1;
        this.chunkMask = (1 << this.chunkBits) - 1;
    }
    Chunker.prototype.nearbyChunks = function (position, distance) {
        var current = this.chunkAtPosition(position);
        var x = current[0];
        var y = current[1];
        var z = current[2];
        var dist = distance || this.distance;
        var nearby = [];
        for (var cx = (x - dist); cx !== (x + dist); ++cx) {
            for (var cy = (y - dist); cy !== (y + dist); ++cy) {
                for (var cz = (z - dist); cz !== (z + dist); ++cz) {
                    nearby.push([cx, cy, cz]);
                }
            }
        }
        return nearby;
    };
    Chunker.prototype.requestMissingChunks = function (position) {
        var _this = this;
        this.nearbyChunks(position).map(function (chunk) {
            if (!_this.chunks[chunk.join('|')]) {
                _this.emit('missingChunk', chunk);
            }
        });
    };
    Chunker.prototype.getBounds = function (x, y, z) {
        var bits = this.chunkBits;
        var low = [x << bits, y << bits, z << bits];
        var high = [(x + 1) << bits, (y + 1) << bits, (z + 1) << bits];
        return [low, high];
    };
    Chunker.prototype.generateChunk = function (x, y, z) {
        var bounds = this.getBounds(x, y, z);
        var chunk = this.generateVoxelChunk(bounds[0], bounds[1], x, y, z);
        var position = [x, y, z];
        chunk.position = position;
        this.chunks[position.join('|')] = chunk;
        return chunk;
    };
    Chunker.prototype.chunkAtCoordinates = function (x, y, z) {
        var bits = this.chunkBits;
        var cx = x >> bits;
        var cy = y >> bits;
        var cz = z >> bits;
        var chunkPos = [cx, cy, cz];
        return chunkPos;
    };
    Chunker.prototype.chunkAtPosition = function (position) {
        var chunkSize = this.chunkSize;
        var x = Math.floor(position[0] / chunkSize);
        var y = Math.floor(position[1] / chunkSize);
        var z = Math.floor(position[2] / chunkSize);
        return [x, y, z];
    };
    ;
    Chunker.prototype.getChunkPosition = function (x, y, z) {
        return this.chunkAtCoordinates(Math.floor(x / this.cubeSize), Math.floor(y / this.cubeSize), Math.floor(z / this.cubeSize));
    };
    Chunker.prototype.voxelIndexFromCoordinates = function (x, y, z) {
        throw new Error('Chunker.prototype.voxelIndexFromCoordinates removed, use voxelAtCoordinates');
    };
    Chunker.prototype.voxelAtPosition = function (pos, val) {
        var cubeSize = this.cubeSize;
        var x = Math.floor(pos[0] / cubeSize);
        var y = Math.floor(pos[1] / cubeSize);
        var z = Math.floor(pos[2] / cubeSize);
        var v = this.voxelAtCoordinates(x, y, z, val);
        return v;
    };
    Chunker.prototype.getVoxel = function (x, y, z) {
        return this.voxelAtCoordinates(x, y, z);
    };
    Chunker.prototype.setVoxel = function (x, y, z, val) {
        return this.voxelAtCoordinates(x, y, z, val);
    };
    Chunker.prototype.voxelAtCoordinates = function (x, y, z, val) {
        var ckey = this.chunkAtCoordinates(x, y, z).join('|');
        var chunk = this.chunks[ckey];
        if (!chunk)
            return 0;
        var mask = this.chunkMask;
        var mx = x & mask;
        var my = y & mask;
        var mz = z & mask;
        var v = chunk.get(mx, my, mz);
        if (typeof val !== 'undefined') {
            chunk.set(mx, my, mz, val);
        }
        return v;
    };
    return Chunker;
}(events_1.EventEmitter));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Chunker;
//# sourceMappingURL=Chunker.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/voxel/Chunker.js
 ** module id = 938
 ** module chunks = 0
 **/